export const TOOLTIP_RIGHT_ALIGNED_CLASSNAME = "obg-m-tooltip-right-aligned";
